export interface Game {
  id: string;
  title: string;
  slug: string;
  playUrl: string;
  device: 'pc' | 'mobile' | 'both';
  main: 'pc' | 'mobile';
  ttplay: '10s' | 'loading' | 'login';
  why: string;
  tags: string[];
  screenshot: string;
  faviconUrl?: string;
}

export const games: Game[] = [
  {
    id: "1",
    title: "2048",
    slug: "2048",
    playUrl: "https://play2048.co/",
    device: "both",
    main: "pc",
    ttplay: "10s",
    why: "숫자 타일을 합쳐 2048을 만드는 중독성 퍼즐",
    tags: ["퍼즐", "전략"],
    screenshot: "https://public.readdy.ai/ai/img_res/51a632e0fcb1b98be601c6be7f7e8087.jpg",
    faviconUrl: "https://www.google.com/s2/favicons?domain=play2048.co&sz=128"
  },
  {
    id: "2",
    title: "Slither.io",
    slug: "slither-io",
    playUrl: "https://slither.io/",
    device: "both",
    main: "mobile",
    ttplay: "loading",
    why: "뱀을 키워 1등을 노리는 멀티플레이어 게임",
    tags: ["액션", "멀티플레이어"],
    screenshot: "https://readdy.ai/api/search-image?query=slither%20io%20snake%20game%20colorful%20glowing%20snakes%20on%20dark%20background%20multiplayer%20arena%20gameplay%20screenshot%20with%20neon%20colors%20and%20food%20pellets%20scattered%20around&width=400&height=300&seq=slitherio&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=slither.io&sz=128"
  },
  {
    id: "3",
    title: "Agar.io",
    slug: "agar-io",
    playUrl: "https://agar.io/",
    device: "both",
    main: "pc",
    ttplay: "login",
    why: "세포를 키워 다른 플레이어를 먹는 생존 게임",
    tags: ["액션", "멀티플레이어"],
    screenshot: "https://readdy.ai/api/search-image?query=agar%20io%20cell%20game%20colorful%20circular%20cells%20on%20grid%20background%20multiplayer%20gameplay%20screenshot%20showing%20large%20and%20small%20colored%20spheres%20with%20simple%20clean%20interface&width=400&height=300&seq=agario&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=agar.io&sz=128"
  },
  {
    id: "4",
    title: "Tetris",
    slug: "tetris",
    playUrl: "https://tetris.com/play-tetris",
    device: "both",
    main: "pc",
    ttplay: "10s",
    why: "블록을 쌓아 라인을 완성하는 클래식 퍼즐",
    tags: ["퍼즐", "클래식"],
    screenshot: "https://readdy.ai/api/search-image?query=tetris%20game%20colorful%20falling%20blocks%20gameplay%20screenshot%20with%20clean%20interface%20showing%20tetromino%20pieces%20stacked%20on%20game%20board%20bright%20colors%20simple%20background&width=400&height=300&seq=tetris&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=tetris.com&sz=128"
  },
  {
    id: "5",
    title: "Krunker.io",
    slug: "krunker-io",
    playUrl: "https://krunker.io/",
    device: "pc",
    main: "pc",
    ttplay: "loading",
    why: "빠른 속도감의 FPS 슈팅 게임",
    tags: ["슈팅", "멀티플레이어"],
    screenshot: "https://readdy.ai/api/search-image?query=krunker%20io%20first%20person%20shooter%20game%20blocky%20pixelated%20graphics%20fps%20gameplay%20screenshot%20with%20weapon%20view%20and%20colorful%20map%20environment%20simple%20clean%20background&width=400&height=300&seq=krunkerio&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=krunker.io&sz=128"
  },
  {
    id: "6",
    title: "Shell Shockers",
    slug: "shell-shockers",
    playUrl: "https://shellshock.io/",
    device: "pc",
    main: "pc",
    ttplay: "login",
    why: "달걀 캐릭터로 싸우는 유니크한 FPS",
    tags: ["슈팅", "멀티플레이어"],
    screenshot: "https://readdy.ai/api/search-image?query=shell%20shockers%20egg%20shooter%20game%20funny%20egg%20characters%20with%20weapons%20colorful%20fps%20gameplay%20screenshot%20showing%20armed%20eggs%20in%20battle%20arena%20simple%20background&width=400&height=300&seq=shellshockers&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=shellshock.io&sz=128"
  },
  {
    id: "cookie-clicker",
    title: "Cookie Clicker",
    slug: "cookie-clicker",
    playUrl: "https://cookieclicker.com/",
    device: "both",
    main: "pc",
    ttplay: "10s",
    why: "뇌 비우고 성장만 보는 '방치형 원조'.",
    tags: ["홀로", "멍때리기"],
    screenshot: "https://readdy.ai/api/search-image?query=cookie%20clicker%20idle%20game%20giant%20cookie%20with%20upgrades%20and%20buildings%20colorful%20cartoon%20style%20interface%20showing%20cookie%20production%20numbers%20and%20achievements%20simple%20clean%20background&width=400&height=300&seq=cookieclicker&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=cookieclicker.com&sz=128"
  },
  {
    id: "little-alchemy-2",
    title: "Little Alchemy 2",
    slug: "little-alchemy-2",
    playUrl: "https://littlealchemy2.com/",
    device: "both",
    main: "pc",
    ttplay: "10s",
    why: "조합 발견하는 순간 '오…' 하는 큐레이션용 퍼즐.",
    tags: ["홀로", "두뇌"],
    screenshot: "https://readdy.ai/api/search-image?query=little%20alchemy%202%20puzzle%20game%20colorful%20element%20icons%20and%20combination%20interface%20showing%20various%20items%20like%20fire%20water%20earth%20air%20with%20clean%20minimalist%20design%20simple%20background&width=400&height=300&seq=littlealchemy2&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=littlealchemy2.com&sz=128"
  },
  {
    id: "not-a-robot",
    title: "Not a Robot",
    slug: "not-a-robot",
    playUrl: "https://neal.fun/not-a-robot/",
    device: "both",
    main: "pc",
    ttplay: "10s",
    why: "초간단인데 계속 눌러보게 되는 심리 트릭 게임.",
    tags: ["홀로", "멍때리기"],
    screenshot: "https://readdy.ai/api/search-image?query=captcha%20verification%20game%20interface%20with%20checkbox%20and%20puzzle%20elements%20minimalist%20design%20showing%20robot%20verification%20challenge%20simple%20clean%20white%20background&width=400&height=300&seq=notarobot&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=neal.fun&sz=128"
  },
  {
    id: "a-dark-room",
    title: "A Dark Room",
    slug: "a-dark-room",
    playUrl: "https://adarkroom.doublespeakgames.com/",
    device: "both",
    main: "pc",
    ttplay: "10s",
    why: "텍스트로 시작해서 서사가 커지는 레전드 브라우저 게임.",
    tags: ["자기 전", "홀로"],
    screenshot: "https://readdy.ai/api/search-image?query=dark%20room%20text%20based%20adventure%20game%20minimalist%20black%20background%20with%20white%20text%20showing%20story%20narrative%20and%20simple%20button%20interface%20atmospheric%20mysterious%20design&width=400&height=300&seq=adarkroom&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=doublespeakgames.com&sz=128"
  },
  {
    id: "lines-frvr",
    title: "Lines FRVR",
    slug: "lines-frvr",
    playUrl: "https://lines.frvr.com/",
    device: "both",
    main: "pc",
    ttplay: "10s",
    why: "한 판이 짧은데 '한 판만 더'가 되는 퍼즐.",
    tags: ["멍때리기", "자기 전"],
    screenshot: "https://readdy.ai/api/search-image?query=lines%20puzzle%20game%20colorful%20balls%20arranged%20in%20grid%20pattern%20with%20clean%20interface%20showing%20matching%20colored%20spheres%20on%20white%20background%20simple%20minimalist%20design&width=400&height=300&seq=linesfrvr&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=frvr.com&sz=128"
  },
  {
    id: "hex-frvr",
    title: "Hex FRVR",
    slug: "hex-frvr",
    playUrl: "https://hex.frvr.com/",
    device: "both",
    main: "pc",
    ttplay: "10s",
    why: "조용한데 몰입 쎈 공간감 퍼즐.",
    tags: ["두뇌", "홀로"],
    screenshot: "https://readdy.ai/api/search-image?query=hexagon%20puzzle%20game%20colorful%20hex%20blocks%20on%20grid%20board%20showing%20tetris%20style%20pieces%20with%20clean%20interface%20bright%20colors%20simple%20background&width=400&height=300&seq=hexfrvr&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=frvr.com&sz=128"
  },
  {
    id: "minesweeper-online",
    title: "Minesweeper Online",
    slug: "minesweeper-online",
    playUrl: "https://minesweeper.online/",
    device: "both",
    main: "pc",
    ttplay: "10s",
    why: "클래식은 클래식. 손이 자동으로 움직임.",
    tags: ["두뇌", "홀로"],
    screenshot: "https://readdy.ai/api/search-image?query=minesweeper%20game%20classic%20grid%20interface%20with%20numbered%20squares%20and%20flags%20showing%20mine%20detection%20puzzle%20clean%20retro%20design%20simple%20background&width=400&height=300&seq=minesweeper&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=minesweeper.online&sz=128"
  },
  {
    id: "sudoku",
    title: "Sudoku",
    slug: "sudoku",
    playUrl: "https://sudoku.com/",
    device: "both",
    main: "pc",
    ttplay: "10s",
    why: "'자기 전' 카테고리 대표로 딱 맞는 두뇌 루틴.",
    tags: ["두뇌", "자기 전"],
    screenshot: "https://readdy.ai/api/search-image?query=sudoku%20puzzle%20game%20clean%20grid%20with%20numbers%20showing%209x9%20board%20with%20pencil%20marks%20minimalist%20interface%20simple%20white%20background%20classic%20design&width=400&height=300&seq=sudoku&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=sudoku.com&sz=128"
  },
  {
    id: "tetr-io",
    title: "TETR.IO",
    slug: "tetr-io",
    playUrl: "https://tetr.io/",
    device: "pc",
    main: "pc",
    ttplay: "10s",
    why: "브라우저 테트리스 중 손맛/속도감 끝판.",
    tags: ["홀로", "멍때리기"],
    screenshot: "https://readdy.ai/api/search-image?query=tetrio%20modern%20tetris%20game%20sleek%20interface%20with%20colorful%20blocks%20falling%20fast%20paced%20gameplay%20showing%20score%20and%20next%20pieces%20clean%20futuristic%20design&width=400&height=300&seq=tetrio&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=tetr.io&sz=128"
  },
  {
    id: "ztype",
    title: "zType",
    slug: "ztype",
    playUrl: "https://zty.pe/",
    device: "pc",
    main: "pc",
    ttplay: "10s",
    why: "타자 + 슈팅 결합. 집중력 '갑자기' 올라감.",
    tags: ["두뇌", "홀로"],
    screenshot: "https://readdy.ai/api/search-image?query=ztype%20typing%20shooter%20game%20space%20theme%20with%20words%20floating%20as%20targets%20dark%20background%20with%20stars%20showing%20typing%20combat%20gameplay%20futuristic%20interface&width=400&height=300&seq=ztype&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=zty.pe&sz=128"
  },
  {
    id: "lichess",
    title: "Lichess",
    slug: "lichess",
    playUrl: "https://lichess.org/",
    device: "both",
    main: "pc",
    ttplay: "loading",
    why: "게스트로도 바로 두뇌전 가능. 체스 입문/실전 다 됨.",
    tags: ["두뇌", "홀로"],
    screenshot: "https://readdy.ai/api/search-image?query=lichess%20chess%20game%20clean%20board%20interface%20with%20wooden%20pieces%20showing%20chess%20match%20in%20progress%20minimalist%20design%20simple%20background%20professional%20look&width=400&height=300&seq=lichess&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=lichess.org&sz=128"
  },
  {
    id: "pokemon-showdown",
    title: "Pokémon Showdown",
    slug: "pokemon-showdown",
    playUrl: "https://play.pokemonshowdown.com/",
    device: "both",
    main: "pc",
    ttplay: "loading",
    why: "설치 없이 포켓몬 배틀 '바로' 돌려보는 시뮬.",
    tags: ["두뇌", "홀로"],
    screenshot: "https://readdy.ai/api/search-image?query=pokemon%20battle%20simulator%20game%20interface%20showing%20two%20pokemon%20facing%20each%20other%20with%20health%20bars%20and%20move%20selection%20buttons%20colorful%20anime%20style%20design%20clean%20background&width=400&height=300&seq=pokemonshowdown&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=pokemonshowdown.com&sz=128"
  },
  {
    id: "loop-tower",
    title: "Loop Tower",
    slug: "loop-tower",
    playUrl: "https://gx.games/games/w69up9/loop-tower/",
    device: "pc",
    main: "pc",
    ttplay: "10s",
    why: "타워 올라가며 스킬 조합하는 roguelike RPG",
    tags: ["홀로", "두뇌"],
    screenshot: "https://readdy.ai/api/search-image?query=loop%20tower%20roguelike%20rpg%20game%20pixel%20art%20style%20showing%20character%20climbing%20tower%20with%20monsters%20and%20skill%20icons%20colorful%20retro%20gaming%20aesthetic%20with%20simple%20clean%20background%20dungeon%20crawler%20gameplay&width=400&height=300&seq=looptower&orientation=landscape",
    faviconUrl: "https://www.google.com/s2/favicons?domain=gx.games&sz=128"
  }
];
